"use client";

import { useEffect, useRef, useState } from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import Autoplay from "embla-carousel-autoplay";
export default function ProjectHighlights() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  const [isPaused, setIsPaused] = useState(false);
  const plugin = useRef(Autoplay({
    delay: 3500,
    stopOnInteraction: false,
    stopOnMouseEnter: true
  }));
  const projects = [{
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1531884/img/east_legon_hills_villa_one.png",
    alt: "East Legon Hills Villa One"
  }, {
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1531884/img/east_legon_hills_villa_two.png",
    alt: "East Legon Hills Villa Two"
  }, {
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1531884/img/east_legon_hills_villa_three.png",
    alt: "East Legon Hills Villa Three"
  }];
  const stats = [{
    label: "Total Units",
    value: "10"
  }, {
    label: "Completion",
    value: "Q42029"
  }, {
    label: "Investment Range",
    value: "$280K - $520K",
    additionalInfo: "Payment Plans Available via Koveris"
  }, {
    label: "USD Yield",
    value: "12-15% USD Yield"
  }];
  return <section id="project-highlights" ref={ref} className="bg-light-background py-20 px-4">
      <div className={`max-w-7xl mx-auto transition-all duration-[var(--duration-medium)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {}
          <div className="relative">
            <Carousel plugins={[plugin.current]} className="w-full" onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)}>
              <CarouselContent>
                {projects.map((project, i) => <CarouselItem key={i} data-index={i}>
                    <Card className="border-0 shadow-medium overflow-hidden">
                      <CardContent className="p-0">
                        <img src={project.image} alt={project.alt} className="w-full h-[500px] object-cover transition-opacity duration-[var(--duration-medium)] ease-[var(--ease-smooth)]" />
                      </CardContent>
                    </Card>
                  </CarouselItem>)}
              </CarouselContent>
              <CarouselPrevious className="left-4 bg-background/80 backdrop-blur-sm border-muted hover:bg-background" />
              <CarouselNext className="right-4 bg-background/80 backdrop-blur-sm border-muted hover:bg-background" />
            </Carousel>
          </div>

          {}
          <div className={`space-y-8 transition-all duration-[var(--duration-medium)] delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div>
              <h2 className="font-display text-4xl lg:text-5xl text-foreground mb-4">
                The East Legon Hills Collection
              </h2>
              <p className="text-muted-foreground text-lg">
                A curated portfolio of 10 luxury residential units designed for discerning international investors seeking verified, transparent real estate opportunities in Accra.
              </p>
            </div>

            {}
            <div className="grid grid-cols-2 gap-6">
              {stats.map((stat, i) => <Card key={i} data-index={i} className="bg-secondary-light border border-border shadow-soft hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)]">
                  <CardContent className="p-6">
                    <div className="text-3xl font-display text-primary mb-2">
                      {stat.value}
                    </div>
                    <div className="text-sm text-muted-foreground uppercase tracking-wide">
                      {stat.label}
                    </div>
                    {stat.additionalInfo && <div className="text-xs text-muted-foreground mt-2">
                        {stat.additionalInfo}
                      </div>}
                  </CardContent>
                </Card>)}
            </div>

            {}
            <div className="pt-4">
              <Link to="/ProjectsPage">
                <Button size="lg" className="group relative overflow-hidden bg-primary text-foreground-primary hover:bg-primary-hover transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]">
                  <span className="relative z-10">View All Projects</span>
                  <span className="absolute bottom-0 left-0 w-full h-0.5 bg-accent scale-x-0 group-hover:scale-x-100 transition-transform duration-[var(--duration-medium)] ease-[var(--ease-out-back)]" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}